import { createReducer, on } from '@ngrx/store';

import * as appWizardActions from '../../../app-wizard/store/actions/app-wizard.actions';
import { AppWizardModuleState } from '../../models/app-wizard.model';

export const appWizardReducer = createReducer<AppWizardModuleState>(
  {} as AppWizardModuleState,
  on(appWizardActions.getApplicationGroupsSuccess, (state, { applicationGroups }) => ({
    ...state,
    applicationGroups,
  })),
  on(appWizardActions.getApplicationRolesSuccess, (state, { roles }) => ({
    ...state,
    roles,
  })),
  on(appWizardActions.getApplicationsSuccess, (state, { applications }) => ({
    ...state,
    applications,
  })),
  on(appWizardActions.createNewApplication, (state, { newApplication }) => ({
    ...state,
    newApplication,
  })),
  on(appWizardActions.createNewApplicationGroup, (state, { newApplicationGroup }) => ({
    ...state,
    newApplicationGroup,
  })),
);
